import clsx from 'clsx';
import { motion } from 'framer-motion';
import { OfferSettings } from './OfferSettings';
import Divider from 'components/Divider/Divider';
import { ProductOfferingType } from 'screens/SelectServices/schemas';
import { useSingleServiceManager } from 'context/SingleServiceManagerContext';

interface AccessCustomizableOptionsProps {
  expand: boolean;
  data: {
    address: string;
    id: string;
    offerings: ProductOfferingType[];
    type?: string;
  };
}

const AccessCustomizableOptions = ({
  expand,
  data,
}: AccessCustomizableOptionsProps) => {
  const { pinnedServices, isUnpinning } = useSingleServiceManager();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={
        expand
          ? {
              opacity: 1,
              height: 'auto',
              display: 'flex',
            }
          : { opacity: 0, display: 'none' }
      }
      transition={{ duration: 0.1, ease: 'easeInOut' }}
      className="rounded rounded-t-none border border-t-0 border-[#47556980]"
    >
      <OfferSettings data={data} />
      <div className="!my-4 mx-4 hidden sm:block">
        <Divider layout="vertical" className="h-full" variant="dotted" />
      </div>
      {pinnedServices[`${data.id}_${data.type}`] ? (
        <div
          className={clsx(
            'relative flex w-1/2 flex-col rounded outline-none outline outline-1 transition-all',
            isUnpinning ? 'animate-poof' : 'animate-slide-in-left-to-right',
          )}
        >
          <OfferSettings data={data} isPinnedSummary={true} />
        </div>
      ) : (
        <div className="w-0 sm:w-1/2" />
      )}
    </motion.div>
  );
};

export default AccessCustomizableOptions;
